// TODO: V2 Transactions module
import { get, set } from '@/helper/localStorage'
import _get from 'lodash/get'
import fields from '@/field/table/transaction'

export default {
  namespaced: true,
  state: {
    tableFields: get('transactionV2TableFields', fields),
    tableData: [],
    tablePagination: get('transactionV2TablePagination'),
    tableKeyword: get('transactionV2TableKeyword'),
    tableSort: get('transactionV2TableSort'),
    tableFilter: get('transactionV2TableFilter', []),
    detailData: get('transactionV2DetailData'),
    loadingTable: false,
    loadingDetail: false,
  },
  getters: {
    tableFields: state => {
      if (!state.tableFields) return undefined
      const visibilities = state.tableFields.reduce((obj, item) => Object.assign(obj, { [item.key]: item.visibility }), {})
      return fields.map(item => ({
        ...item,
        visibility: item.key in visibilities ? visibilities[item.key] : item.visibility,
      }))
    },
    tableSort: state => {
      if (!state.tableSort) return undefined
      const symbol = state.tableSort.direction === 'desc' ? '-' : ''
      return `${symbol}${state.tableSort.key}`
    },
    tableData: state => {
      if (!state.tableData) return []
      return state.tableData.map(item => ({
        ...item,
      }))
    },
    detailData: state => {
      if (!state.detailData) return undefined
      return { ...state.detailData }
    },
    tableFilter: state => {
      if (!state.tableFilter) return []
      return state.tableFilter
        .reduce((acc, elem) => Object.assign(acc, {
          [`filter[${elem.key}]`]: Array.isArray(elem.value)
            ? elem.value.join(',')
            : elem.value,
        }), {})
    },
    tableParams: (state, getters, rootState) => ({
      'filter[keyword]': state.tableKeyword,
      ...getters.tableFilter,
      sort: getters.tableSort,
      page: _get(state, 'tablePagination.current_page', 1),
      limit: rootState.appConfig.settings.tablePerPage,
    }),
  },
  mutations: {
    SET_TABLE_FIELDS(state, val) {
      set('transactionV2TableFields', val)
      state.tableFields = val
    },
    RESET_TABLE_FIELDS(state) {
      set('transactionV2TableFields', fields)
      state.tableFields = fields
    },
    SET_TABLE_DATA(state, val) {
      state.tableData = val
    },
    SET_TABLE_PAGINATION(state, val) {
      set('transactionV2TablePagination', val)
      state.tablePagination = val
    },
    SET_TABLE_KEYWORD(state, val) {
      set('transactionV2TableKeyword', val)
      state.tableKeyword = val
    },
    SET_DETAIL_DATA(state, val) {
      set('transactionV2DetailData', val)
      state.detailData = val
    },
    SET_TABLE_SORT(state, val) {
      set('transactionV2TableSort', val)
      state.tableSort = val
    },
    SET_TABLE_FILTER(state, val) {
      set('transactionV2TableFilter', val)
      state.tableFilter = val
    },
    SET_LOADING_TABLE(state, val) {
      state.loadingTable = val
    },
    SET_LOADING_DETAIL(state, val) {
      state.loadingDetail = val
    },
  },
  actions: {
    getTableData({ commit, getters }) {
      commit('SET_LOADING_TABLE', true)
      const { tableParams: params } = getters
      return this._vm.$http.get('/v3/admin/transactions', { params })
        .then(({ data }) => {
          // The v3 common shape is { data: rows, meta }
          commit('SET_TABLE_DATA', data.data || data.rows || [])
          commit('SET_TABLE_PAGINATION', data.meta || data.pagination || {})
        })
        .finally(() => {
          commit('SET_LOADING_TABLE', false)
        })
    },
    getDetail({ commit }, id) {
      commit('SET_LOADING_DETAIL', true)
      return this._vm.$http.get(`/v3/admin/transactions/${id}`)
        .then(({ data }) => {
          commit('SET_DETAIL_DATA', data.data)
        })
        .finally(() => {
          commit('SET_LOADING_DETAIL', false)
        })
    },
  },
}
